export default class TaxVariant {
  /** Общая СН. */
  static get OSN () {
    return '0'
  }

  /** Упрощенная СН (доходы).  */
  static get USN_INCOME () {
    return '1'
  }

  /**  Упрощенная СН (доходы минус расходы). */
  static get USN_INCOME_OUTCOME () {
    return '2'
  }

  /** Единый налог на вмененный доход. */
  static get ENVD () {
    return '3'
  }

  /** Единый сельскохозяйственный налог. */
  static get ESN () {
    return '4'
  }

  /** Патентная СН. */
  static get PATENT () {
    return '5'
  }

  static getName (enumValue) {
    console.log(enumValue)
    switch (enumValue) {
      case TaxVariant.OSN:
        return 'Общая СН'
      case TaxVariant.USN_INCOME:
        return 'Упрощенная СН (доходы)'
      case TaxVariant.USN_INCOME_OUTCOME:
        return 'Упрощенная СН (доходы минус расходы)'
      case TaxVariant.ENVD:
        return 'Единый налог на вмененный доход'
      case TaxVariant.ESN:
        return 'Единый сельскохозяйственный налог'
      case TaxVariant.PATENT:
        return 'Патентная СН'

      default:
        return enumValue
    }
  }
}
